import { LOGGING_SERVICE_URL } from "../../constant";

const sendLogs = async (level, app, id, message, response_time) => {
    try {
        // Replace with the actual backend service URL

        const loggingServiceUrl = LOGGING_SERVICE_URL;

        const response = await fetch(loggingServiceUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ level, app, id, message, response_time }),
        });
        if (!response.ok) {
            throw new Error(`Failed to send log: ${response.statusText}`);
        }

        const data = await response.json();
        console.log('Log sent successfully:', data);
    } catch (error) {
        console.error('Error calling logging service:', error);
    }
};

export default sendLogs;